/**
 * Created by Ding on 12/04/2017.
 * Initialed by louyunchuan on 17/3/28.
 */

import React, { Component, PropTypes } from 'react';
import { Link } from 'react-router';
import Moment from 'moment';
import querystring from 'querystring';
import { Table, Popover, Icon } from 'antd';

import PositionsForm from './PositionsForm';
import { ajaxGet, ajaxPost } from '../../utils/ajax';


export default class Positions extends Component {

    static defaultProps = {
        statuses: [],
        locations: [],
    };

    static propTypes = {
        location: PropTypes.object.isRequired,
        history: PropTypes.object.isRequired,
    };

    state = {
        statuses: [],
        positions: [],
        total: 0,
        locations: [],
    };

    componentDidMount() {
        this.getStatus();
        this.getPositions(querystring.parse(this.props.location.search ? this.props.location.search.slice(1) : ''));
        this.getLocations();
    }

    componentWillReceiveProps(newProps) {
        this.getPositions(querystring.parse(newProps.location.search ? newProps.location.search.slice(1) : ''));
    }

    onSearch = (params) => {
        const modifiedParams = Object.assign({}, params);
        if (params.createTime && params.createTime.length > 0) {
            modifiedParams.createTimeStart = Moment(params.createTime[0])
                .format('YYYY-MM-DD 00:00:00');
            modifiedParams.createTimeEnd = Moment(params.createTime[1])
                .format('YYYY-MM-DD 23:59:59');
            delete modifiedParams.createTime;
        }
        if (params.refreshTime && params.refreshTime.length > 0) {
            modifiedParams.refreshTimeStart = Moment(params.refreshTime[0])
                .format('YYYY-MM-DD 00:00:00');
            modifiedParams.refreshTimeEnd = Moment(params.refreshTime[1])
                .format('YYYY-MM-DD 23:59:59');
            delete modifiedParams.refreshTime;
        }
        const newParams = {};
        Object.keys(modifiedParams)
            .filter(item => modifiedParams[item] !== undefined &&
                modifiedParams[item] !== null && modifiedParams[item] !== '')
            .forEach((item) => {
                newParams[item] = modifiedParams[item];
            });
        this.props.history.push(`${this.props.location.pathname}${Object.keys(newParams).length > 0 ?
            `?${querystring.stringify(newParams)}` : ''}`);
    };

    onPageChange = (pageNum) => {
    };


    getPositions = (params) => {
        const newParams = Object.assign({
            pageSize: 10,
            pageNum: 1,
        }, params);
        ajaxPost('/recruit/api/hunter/searchJdInfo', newParams, (rawData) => {
            this.setState({
                positions: rawData.data.items,
                total: rawData.data.total,
                pageNum: rawData.data.page,
            });
        });
    };

    getLocations = () => {
        ajaxGet('/recruit/api/hunter/selectWorkArea', {}, (rawData) => {
            this.setState({
                locations: rawData.data,
            });
        });
    };

    getStatus = () => {
        ajaxGet('/recruit/api/hunter/getHunterEnumMap', {}, (rawData) => {
            this.setState({
                statuses: rawData.data.JdPublishConfirmStatusEnum,
            });
        });
    };

    columns = [{
        title: '职位名称',
        dataIndex: 'jobName',
        width: '26%',
        render: (text, record) => (
            <div className="fixed-table-cell" title={`${text}(${record.jdNo})`}>
                <Link to={`/position_${record.jdId}/detail`}>{text}({record.jdNo})</Link>
            </div>
        ),
    }, {
        title: '工作地点',
        dataIndex: 'workArea',
        width: '10%',
    }, {
        title: '推荐人数',
        dataIndex: 'reference',
        width: '10%',
    }, {
        title: '职位状态',
        dataIndex: 'status',
        width: '10%',
        render: (text) => {
            if (this.state.statuses.length > 0 &&
                this.state.statuses.find(item => item.code === text)
            ) {
                if (text == '3') {
                    return (
                        <Popover content='职位已取消， 已在流程中的人选不受影响'>
                            <div style={{ cursor: 'help' }}>
                                <span style={{ marginRight: '5px' }}>{this.state.statuses.find(item => item.code === text).desc}</span>
                                <Icon type="question-circle" />
                            </div>
                        </Popover>
                    )
                } else {
                    return this.state.statuses.find(item => item.code === text).desc;
                }
            }
            return '';
        },
    }, {
        title: '职位处理人',
        dataIndex: 'recruiterName',
        width: '10%',
    }, {
        title: '发布日期',
        dataIndex: 'createTime',
        width: '12%',
        render: (text) => {
            if (text) {
                return text.slice(0, 10);
            }
            return '';
        },
    }, {
        title: '刷新日期',
        dataIndex: 'refreshTime',
        width: '12%',
        render: (text) => {
            if (text) {
                return text.slice(0, 10);
            }
            return '';
        },
        sorter: true,
    }, {
        title: '操作',
        dataIndex: 'jdId',
        width: '10%',
        render: (text, record) => {
            if (record.status === 2) {
                return <Link to={`/position_${text}/recommend_candidate`}>推荐候选人</Link>;
            }
            return '';
        },
    }];

    handleTableChange = ({ current: pageNum }, filters, sorter) => {
        const params = Object.assign({}, querystring.parse(this.props.location.search ?
            this.props.location.search.slice(1) : ''), { pageNum });
        if (sorter && sorter.field === 'refreshTime') {
            params.refreshSort = sorter.order === 'ascend' ? 1 : 0;
        }
        this.onSearch(params);
    };

    render() {
        const paginationConfig = {
            pageSize: 10,
            total: this.state.total,
            showQuickJumper: true,
            current: this.state.pageNum,
        };

        return (
            <div>
                <PositionsForm
                    handleSubmit={this.onSearch}
                    statuses={this.state.statuses}
                    locations={this.state.locations}
                    {...querystring.parse(this.props.location.search ? this.props.location.search.slice(1) : '')}
                />

                <Table
                    className="loose-table-no-checkbox"
                    rowKey={record => record.id}
                    columns={this.columns}
                    dataSource={this.state.positions}
                    pagination={paginationConfig}
                    onChange={this.handleTableChange}
                />
            </div>
        );
    }
}
